var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.14286 19.0723H11.2857M6.14286 13.9294H11.2857M6.14286 8.78655H7.42857M11.2857 1.07227H5.11429C3.67416 1.07227 2.95408 1.07227 2.40403 1.35254C1.92017 1.59906 1.5268 1.99244 1.28027 2.47629C1 3.02635 1 3.74642 1 5.18655V20.1008C1 21.541 1 22.2611 1.28027 22.8111C1.5268 23.2949 1.92017 23.6884 2.40403 23.9348C2.95408 24.2151 3.67416 24.2151 5.11429 24.2151H11.2857M11.2857 1.07227L19 8.78655M11.2857 1.07227V6.72941C11.2857 7.44947 11.2857 7.80951 11.4259 8.08454C11.5492 8.32646 11.7457 8.52315 11.9877 8.64642C12.2627 8.78655 12.6227 8.78655 13.3429 8.78655H19M19 8.78655V12.0008",
    stroke: "#5EB0CA",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.db1367770f08a069f28d56feabb05792.svg";
export { ForwardRef as ReactComponent };